import { DataLayerEvent, pushEvent } from './datalayer/helpers'

import ChildrenBirthdayValidator from '@/modules/search/ChildrenBirthdayValidator'

const $ = require('jquery')

const ajaxLoader = require('./ajaxLoader')
const { URL_API, SELECTOR } = require('./api')
const { bookingForm } = require('./bookingForm')
const FORMS = require('./forms')
const { globals } = require('./globals')

// =========================================================================
// Booking form widget
// =========================================================================
const formBookingWidgetAJAX = {
  init () {
    $(document).on('click', '.offer-sidebar .btn-booking', function() {
      pushEvent(DataLayerEvent.itemEvent('begin_checkout', window.offer_item || {})[0])
    })

    const bookingPlaceholder = $('#booking-widget-placeholder')
    if (bookingPlaceholder.length == 0) {
      return
    }

    const loaded = $('.offer-sidebar__header')
    if (loaded.length > 0) {
      return
    }

    function formBookingWidget (reinit) {
      const bookingFormElem = $('.form-booking')

      if (bookingFormElem.exists()) {
        const bookingFormCs = bookingFormElem.find('fieldset > div')
        const elementsInitDropdowns = [
          '.form-booking .custom-select-date .section-title',
          '.form-booking .custom-select-airport .section-title',
          '.form-booking .custom-select-people .section-title',
          '.form-booking .custom-select-room .section-title',
          '.form-booking .custom-select-food .section-title',
        ]
        const csPeopleElem = bookingFormElem.find('.custom-select-people .form-group label + div')
        const csPeopleElemChildBirthdayVal = bookingFormElem.find('.custom-select-people .form-group').slice(2)
        const csPeopleElemAdultsInput = csPeopleElem.eq(0).find('input')
        const csPeopleElemChildrenInput = csPeopleElem.eq(1).find('input')
        let urlGetData
        let urlPostData

        const childBirthdayValue = function(index) {
          const childBirthDate = csPeopleElemChildBirthdayVal.eq(index).find('input').attr('value')
          return childBirthDate
        }

        let bookingFormObjValues = {
          Dates: bookingFormElem.find('input[name="Dates"]:checked').val(),
          Airports: bookingFormElem.find('input[name="Airports"]:checked').val(),
          ReturnAirport: bookingFormElem.find('input[name="Airports"]:checked + input[name="ReturnAirport"]').val(),
          Rooms: bookingFormElem.find('input[name="Rooms"]:checked').val(),
          BoardStandards: bookingFormElem.find('input[name="BoardStandards"]:checked').val(),
          Adults: csPeopleElemAdultsInput.val(),
          Children: csPeopleElemChildrenInput.val(),
          Child1: childBirthdayValue(0),
          Child2: childBirthdayValue(1),
          Child3: childBirthdayValue(2),
          Child4: childBirthdayValue(3),
          Child5: childBirthdayValue(4),
          Child6: childBirthdayValue(5),
        }

        let _bookingFormObjValues

        if (!$('.offer-sidebar .custom-select-people').hasClass('initialize-prices')) {
          $('.offer-sidebar .custom-select-people').addClass('initialize-prices')
          $('.offer-sidebar .custom-select-people').on('popup:closed', function() {
            if (_bookingFormObjValues) {
              requestForGetPriceOffer(_bookingFormObjValues)
            }
          })
        }

        const updateBirthdayValue = function(index, value) {
          csPeopleElemChildBirthdayVal.eq(index).find('input').attr('value', value)
        }

        const updateBookingFormObjValues = function(bookingFormObjValues, inputName, inputValue) {
          let key = null
          for (key in bookingFormObjValues) {
            if (bookingFormObjValues.hasOwnProperty(key)) {
              if (key == inputName) {
                bookingFormObjValues[key] = inputValue
              }
            }
          }
          return bookingFormObjValues
        }

        // -------------------------------------------------------------------
        // bookingForm: Update prices
        // -------------------------------------------------------------------
        const requestForGetPriceOffer = function(bookingFormObjValues) {
          if (bookingFormObjValues.Dates == ':') {
            const today = new Date()
            const dd = today.getDate()
            const mm = today.getMonth() + 1 //January is 0!
            const yyyy = today.getFullYear()

            const nextMonth = today.setDate(today.getDate() + 30)
            const ddNextMonth = nextMonth.getDate()
            const mmNextMonth = nextMonth.getMonth() + 1 //January is 0!
            const yyyyNextMonth = nextMonth.getFullYear()

            bookingFormObjValues.Dates = `${yyyy + mm + dd}:${yyyyNextMonth}${mmNextMonth}${ddNextMonth}`
          }

          if (!bookingFormObjValues.BoardStandards) {
            bookingFormObjValues.Rooms = 1
          }

          urlGetData = `&dates=${bookingFormObjValues.Dates}&Airports=${bookingFormObjValues.Airports}&ReturnAirport=${bookingFormObjValues.ReturnAirport}&Rooms=${bookingFormObjValues.Rooms}&BoardStandards=${bookingFormObjValues.BoardStandards}&Adults=${bookingFormObjValues.Adults}&Children=${bookingFormObjValues.Children}`
          urlPostData = `&Adults=${bookingFormObjValues.Adults}&Children=${bookingFormObjValues.Children}`

          if (bookingFormObjValues.Children > 0) {

            const bookingFormObjValues2 = bookingFormObjValues
            const children = bookingFormObjValues.Children
            for (let i = 6; i > children; i--) {
              const prop = `Child${i}`
              delete bookingFormObjValues2[prop]
            }

            // Create query string based on Object
            const urlGetDataEncoded = $.param(bookingFormObjValues2, true)
            const surlGetDataDecoded = decodeURIComponent(urlGetDataEncoded)

            urlPostData = `&${surlGetDataDecoded}`
            urlGetData = `&${surlGetDataDecoded}`
          }
          // -----------------------------------------------------------------
          formBookingWidget.bookingFormObjValues = bookingFormObjValues
          bookingForm(urlGetData, urlPostData, bookingFormObjValues, formBookingWidget)
        }

        for (let i = 0; i < elementsInitDropdowns.length; i++) {
          FORMS.helpers.csDropdownRun($(elementsInitDropdowns[i]))
        }
        $('.form-booking .custom-select-date').find('.dropdown-menu').perfectScrollbar()

        // ---------------------------------------------------------------------
        // bookingForm: Set checked values
        // ---------------------------------------------------------------------
        FORMS.helpers.csRadiosList.radioLabel('.form-group', bookingFormCs).find('input:checked').each(function() {
          const value = $.trim($(this).next('label').html())
          const $dropdown = $(this).closest('.dropdown-menu')

          if ($dropdown.find('.airportSelected').length) {
            const $airportOption = $dropdown.find('.option input:checked').parent()
            const airportTitle = $airportOption.siblings('.airportSelected').html()

            $dropdown.siblings('.section-title').addClass('customSize')
            $dropdown.siblings('.section-title').html(airportTitle)
          } else {
            $dropdown.siblings('.section-title').html(value)
          }
        })

        // ---------------------------------------------------------------------
        // bookingForm: custom select people
        // ---------------------------------------------------------------------
        //log.debug(bookingFormObjValues);
        if (!reinit) {
          // Enable checking for children default birthdays
          const offerSidebar = bookingFormElem.parents('.offer-sidebar')
          offerSidebar.find('.btn-booking').on('click', function(e) {
            const form = $(e.target).parents('.offer-sidebar').find('form')
            if (!new ChildrenBirthdayValidator(form.get(0)).validate()) {
              e.preventDefault()
            }
          })

          FORMS.customSelect.people.init(SELECTOR.FORM_BOOKING, false,
            function(inputName, inputValue, e) {
              // -------------------------------------------------------------
              // Change amount of Adults or Children
              // -------------------------------------------------------------
              // bookingForm: Update prices
              bookingFormObjValues[inputName] = inputValue

              log.debug(bookingFormObjValues)

              // BookingForm: Update prices
              const $sender = $(e.target)

              if ($sender.parents('.offer-sidebar').length === 0) {
                requestForGetPriceOffer(bookingFormObjValues)
              }

              _bookingFormObjValues = bookingFormObjValues
            },
            function(objChildBirthday) {
              // -------------------------------------------------------------
              // Change birthday of child
              // -------------------------------------------------------------
              // bookingForm: Update prices
              bookingFormObjValues = updateBookingFormObjValues(
                bookingFormObjValues,
                objChildBirthday.index,
                objChildBirthday.dateBirthday
              )
              log.debug(bookingFormObjValues)

              //Update html content
              let childIndex = objChildBirthday.index.replace('Child', '')
              childIndex = parseInt(childIndex)
              childIndex = childIndex - 1

              updateBirthdayValue(childIndex, objChildBirthday.dateBirthday)

              //RequestForGetPriceOffer(bookingFormObjValues);
              _bookingFormObjValues = bookingFormObjValues
            })
        }

        // ---------------------------------------------------------------------
        // bookingForm: Change checked values
        // ---------------------------------------------------------------------
        FORMS.helpers.csRadiosList.radioLabel('.form-group', bookingFormCs).find('label').on('click', function() {
          const value = $.trim($(this).html())
          const name = $(this).siblings('input').prop('name')

          $(this).closest('.dropdown-menu').find('input').each(function() {
            $(this).removeAttr('checked')
          })

          $(this).siblings('input').prop('checked', true)
          const inputValue = $(this).siblings('input').val()

          FORMS.helpers.csRadiosList.onChange(
            $(this),
            $(this).closest('.dropdown-menu').siblings('.section-title').html(value)
          )

          // BookingForm: Update prices
          bookingFormObjValues = updateBookingFormObjValues(
            bookingFormObjValues,
            name,
            inputValue
          )

          if (name === 'Airports') {
            // IG-1179 Airports is an unfortunate special case where 2 values need to be updated
            //         and the default engine is not ready for it so we do it manually.
            //         When re-writing the booking widget we need to handle this case properly
            bookingFormObjValues = updateBookingFormObjValues(
              bookingFormObjValues,
              'ReturnAirport',
              $(this).siblings('input[name="ReturnAirport"]').val()
            )
          }

          requestForGetPriceOffer(bookingFormObjValues)
        })

        $('.custom-select-room input:radio, .custom-select-food input:radio, .custom-select-airport input:radio, .custom-select-date input:radio').each(function() {
          if ($(this).is(':disabled')) {
            $(this).parent().prepend('<div class="blockedOverlay" style="position:absolute;top:0;left:0;width:105%;height:100%;z-index:9999;"></div>')
          }
        })

        // Check if stored participants match current selection
        const storedData = localStorage.getItem('bookingForm')
        if (storedData) {
          const { participants } = JSON.parse(storedData)
          if (participants) {
            const currentAdults = parseInt(csPeopleElemAdultsInput.val()) || 0
            const currentChildren = parseInt(csPeopleElemChildrenInput.val()) || 0
            
            const storedAdults = participants.filter(p => p.type === 'adult').length
            const storedChildren = participants.filter(p => p.type === 'child' || p.type === 'infant').length
            
            if (storedAdults !== currentAdults || storedChildren !== currentChildren) {
              localStorage.removeItem('bookingForm')
            }
          }
        }
      }
    }

    function animateScrollOnClick (element) {
      element.addEventListener('click', () => {
        $('html, body').animate({
          scrollTop: $('#all-offers').offset().top,
        }, 700)
      })
    }

    function hideDropdown (element) {
      if (element && element.offsetParent && element.offsetParent.className.includes('custom-select')) {
        element.offsetParent.querySelector('.dropdown-menu').classList.add('hidden')
      }
    }

    const parametersIndex = window.location.href.indexOf('?')
    let url = null
    let hotelSlug = null
    if (parametersIndex > 0) {
      hotelSlug = window.location.href.slice(
        window.location.href.lastIndexOf('/') + 1,
        window.location.href.indexOf('?'))
      url = `&${window.location.href.slice(window.location.href.indexOf('?') + 1)}`
    } else {
      hotelSlug = window.location.href.slice(window.location.href.lastIndexOf('/') + 1)
      url = ''
    }
    const bookingURL = `${URL_API.GetBookingWidget}?hotelSlug=${hotelSlug}${url}`

    ajaxLoader.init({
      devTest: true,
      url: bookingURL,
      method: 'GET',
      type: 'html-prepend',
      placeholder: bookingPlaceholder,
      callback () {
        $('.offer-sidebar__preload').remove()
      },
      afterSuccess () {
        $('#booking-widget-placeholder').attr('id', 'loaded')
        SELECTOR.FORM_BOOKING = $('.form-booking')
        formBookingWidget(false)

        const offerData = $('.btn-offers')
        const offerId = offerData.attr('data-offer')

        if (typeof globals.updateValueCallback === 'function') {
          globals.updateValueCallback(SELECTOR.FORM_BOOKING, offerId)
        }

        // Disable closing popups on click except for close button
        $('div[class*=" custom-select-"] .dropdown-menu').click(e => {
          if (!e.target.classList.contains('close'))
            e.stopPropagation()
        })

        const elements = `
          .offer-sidebar .modal-link,
          .form-booking .custom-select-date > span[role="button"],
          .form-booking .custom-select-airport > span[role="button"],
          .form-booking .custom-select-people > span[role="button"],
          .form-booking .custom-select-duration > span[role="button"],
          .form-booking .custom-select-room > span[role="button"],
          .form-booking .custom-select-food > span[role="button"]`

        document.querySelectorAll(elements).forEach(animateScrollOnClick)
        document.querySelectorAll(elements).forEach(hideDropdown)

        $('.offer-sidebar button[data-target="#modal-offers"]').removeAttr('data-target')
      },
    })
  },
}

module.exports = formBookingWidgetAJAX




// WEBPACK FOOTER //
// ./src/modules/formBookingWidgetAJAX.js